import { atom } from 'jotai';

// Pause global refetch triggered by the SSE `DEAL` signal, but only
// when importing coupons via CSV and running the step builder.
export const pauseCouponCsvRefetchState = atom<boolean>(false);
